import { h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { box, container, loadingButton, pageTitle } from '@/ui/components';
import { useTask } from '@/ui/concerns';
import { create } from '@/services/api/resources/category';
import { toastAndRedirect } from '@/ui/helpers/uiHelper';
import { hasFeature, hasPermission, Permissions } from '@/ui/auth/auth';
import { useCategoryForm } from './useCategoryForm';
import { useCategoryRecord } from './useCategoryRecord';
import { renderForbiddenPage } from '../error/ForbiddenPage';
import { renderResourceTeaserPage } from '@/ui/pages/teasers/ResourceTeaserPage';
import { AdministrationTabNames, queryTabName } from '@/ui/components/navigation/constants';

export const CategoryCreatePage = defineComponent({
  name: 'CategoryCreatePage',
  setup() {
    if (!hasFeature('analytics')) {
      return renderResourceTeaserPage(
        t('common.categories'),
        t('category.teaser'),
        t('common.teaser'),
        'categoryIndex',
      );
    }

    if (!hasPermission(Permissions.MANAGE_CATEGORIES)) {
      return renderForbiddenPage;
    }

    // create empty record
    const record = useCategoryRecord();

    // send record
    const sendRecord = useTask(
      () => create(record.value),
      () => {
        toastAndRedirect(t('category.created'), 'administration', { [queryTabName]: AdministrationTabNames.CATEGORY });
      },
    );

    // form
    const { formFields, handleSubmit } = useCategoryForm(record, sendRecord);

    return function render() {
      return container(
        [
          pageTitle(t('category.create')),
          box([
            h('form', [
              ...formFields(),
              loadingButton(
                t('category.create'),
                handleSubmit,
                sendRecord.state.value.pending,
              ),
            ]),
          ]),
        ],
        'narrow',
      );
    };
  },
});
